import React from "react";

const WEBSITE_URL = process.env.REACT_APP_WEBJESTERS_SITE_URL;
if (!WEBSITE_URL) throw new Error("REACT_APP_WEBJESTERS_SITE_URL must be configured");

export const WebJestersSiteLink = ({ children = "WebJesters", testid, className = "" }) => (
    <a
        href={WEBSITE_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={testid}
        aria-label="Visit the WebJesters website (opens in a new tab)"
        className={`hover:text-zinc-100 hover:underline underline-offset-4 transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-zinc-400 ${className}`}
    >
        {children}
    </a>
);